module.exports = __webpack_public_path__ + "static/media/Services-02.ba722fdb.jpg";